module.exports = __webpack_public_path__ + "img/jar.19807157.svg";